/** Etykiety i warianty chipów statusu terminu (ekran „Terminy procesowe"). */

import type { StatusVariant } from '@/design/components'
import { daysUntil } from '@/lib/format'
import type { DeadlineSource, DeadlineStatus } from './types'

export const STATUS_LABEL: Record<DeadlineStatus, string> = {
  pending: 'Nierozpoczęte',
  in_progress: 'W realizacji',
  needs_attention: 'Wymaga uwagi',
  planned: 'Zaplanowane',
  done: 'Zakończony',
  cancelled: 'Anulowany',
}

export const STATUS_VARIANT: Record<DeadlineStatus, StatusVariant> = {
  pending: 'neutral',
  in_progress: 'warning',
  // Mockup „Terminy procesowe": „Wymaga uwagi" jest bursztynowe — czerwień rezerwujemy
  // dla terminów krytycznych (patrz `chipVariant`).
  needs_attention: 'warning',
  planned: 'neutral',
  done: 'success',
  cancelled: 'neutral',
}

/** Terminy z grupy „KRYTYCZNE — DO 3 DNI" mają czerwony chip niezależnie od statusu prac. */
const CRITICAL_DAYS = 3
const CLOSED: DeadlineStatus[] = ['done', 'cancelled']

/** Termin zamknięty — zakończony albo anulowany (odpowiednik `CLOSED_STATUSES` w API). */
export function isClosed(status: DeadlineStatus): boolean {
  return CLOSED.includes(status)
}

export function chipVariant(status: DeadlineStatus, dueDate: string | null | undefined): StatusVariant {
  if (isClosed(status)) return STATUS_VARIANT[status]
  const days = daysUntil(dueDate)
  if (days !== null && days <= CRITICAL_DAYS) return 'danger'
  return STATUS_VARIANT[status]
}

/** Kolejność w selectach (statusy zamykające na końcu). */
export const STATUS_OPTIONS: { value: DeadlineStatus; label: string }[] = (
  ['pending', 'in_progress', 'needs_attention', 'planned', 'done', 'cancelled'] as const
).map((value) => ({ value, label: STATUS_LABEL[value] }))

export const SOURCE_LABEL: Record<DeadlineSource, string> = {
  ai: 'z pisma (AI)',
  manual: 'ręcznie',
}
